import  { useState, useEffect } from 'react';
import useSWR from 'swr';
import FastTypingText from './FastTypingText';
import { API_BASE } from '../../api';

const PING_URL = `${API_BASE}/ping`;

const fetcher1 = async () => {
    try {
        const response = await fetch(PING_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        return error;
    }
};

const ServerAiStatus = () => {
    const [aiServChecked, setAiServChecked] = useState(null);
    const [aiServResponseCgi, setAiServResponseCgi] = useState(null);
    const [aiServResponseError, setAiServResponseError] = useState(null);
    const [countdown, setCountdown] = useState(180);

    useEffect(() => {
        const storedAiServChecked = localStorage.getItem('aiServChecked');
        const initialAiServChecked = storedAiServChecked === 'true' ? true : false;
        setAiServChecked(initialAiServChecked);

        const storedAiServResponseCgi = localStorage.getItem('aiServResponseCgi');
        setAiServResponseCgi(storedAiServResponseCgi);

        const storedAiServResponseError = localStorage.getItem('aiServResponseError');
        setAiServResponseError(storedAiServResponseError);
    }, []);

    useEffect(() => {
        if (aiServChecked !== null) {
            localStorage.setItem('aiServChecked', aiServChecked);
        }
        if (aiServResponseCgi !== null) {
            localStorage.setItem('aiServResponseCgi', aiServResponseCgi);
        }
        if (aiServResponseError !== null) {
            localStorage.setItem('aiServResponseError', aiServResponseError);
        }
    }, [aiServChecked, aiServResponseCgi, aiServResponseError]);

    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000);

        if (countdown === 0) {
            clearInterval(countdownInterval);
            setCountdown(180);
        }

        return () => clearInterval(countdownInterval);
    }, [aiServChecked, countdown]);

    const { data: apitest, error: aiServError, isLoading: aiServLoading } = useSWR(
        PING_URL,
        fetcher1,
        {
            refreshInterval: 3 * 60 * 1000,
            revalidateIfStale: true,
            revalidateOnFocus: false,
            revalidateOnReconnect: true,
            refreshWhenHidden: false,
            refreshWhenOffline: true,
            revalidateOnMount: true,
            errorRetryInterval: 3 * 60 * 1000,
        }
    );

    useEffect(() => {
        if (apitest && !aiServError) {
            setAiServChecked(true);
            setAiServResponseCgi(apitest.response_cgi);
            setAiServResponseError(apitest.response_error);
        }
    }, [apitest, aiServError]);

    return (
        <div className='server-status'>
            <hserv>Server Status</hserv>
            <br />
            <br />
            <pserv className={aiServLoading ? 'loading' :  aiServChecked === true && aiServResponseCgi === true ? 'online' : 'offline'}>
                <span className='lamp'>⦿</span>
                Internal Endpoint: {aiServLoading ? 'Loading...' :  aiServChecked === true && aiServResponseCgi === true ? 'Online' : 'Offline'}
            </pserv>
            <br />
            <br />
            <pserv className={aiServLoading ? 'loading' : aiServResponseError === false ? 'offline' : 'online'}>
                {aiServLoading ? null : aiServResponseError === false ? (
                    <FastTypingText text={"Endpoint down. Οι απαντήσεις δεν μπορούν να ελεγχθούν. Παρακαλώ δοκιμάστε αργότερα"} />
                ) : (
                    <FastTypingText text={"Εφαρμογή σε λειτουργία. Δυνατότητα ελέγχου απαντήσεων"} />
                )}
            </pserv>
            <br />
            <br />
            <pserv className={aiServLoading ? 'loading' : aiServChecked === true && aiServResponseError !== false ? 'online' : 'offline'}>
                <span className='lamp'>⦿</span>
                AI Endpoint Service: {aiServLoading ? 'Loading...' : aiServResponseError !== false ? 'Online' : 'Offline'}
            </pserv>
            <br />
            <br />
            <pserv className={aiServLoading ? 'loading' : aiServChecked === true && aiServResponseError !== false ? 'online' : 'offline'}>
                {aiServLoading ? null : aiServChecked && aiServResponseError !== false ? (
                    <FastTypingText text={"Οι απαντήσεις με κώδικά μπορούν να ελεγχθούν."} />
                ) : (
                    <FastTypingText text={"Οι απαντήσεις με κώδικά δεν μπορούν να ελεγχθούν"} />
                )}
            </pserv>
            <br />
            {aiServChecked && !aiServLoading && <hserv style={{ color: 'orange', fontSize: '10px' }}>Ο έλεγχος θα ξαναγίνει σε: {countdown} δευτερολεπτά.</hserv>}
        </div>
    );
};

export default ServerAiStatus;
